import { ref, reactive, onBeforeMount, watch, getCurrentInstance } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useTransferStockForm(props) {
  const vm = getCurrentInstance().proxy;
  const {fetchPrivilegeEntryDetail, fetchTransferQty} = inventoryPrivilegeFormModel();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
    openWarningModal
  } = useValidationModal();

  const formReward = reactive({
    entryId : "",
    name : "",
    reference : "",
    privilegeType : "",
    couponType : "",
    couponTypeVal : "",
    image : "",
    note : "",
  })

  const loading = reactive({
    form : false
  })

  const formManageStock = reactive({
    removalStrategy : 1
  })

  const qtyTotal = ref(0);
  const quantityValue = reactive({
    add : 0
  })

  const removalOptions = ref([
    { label: "FIFO", value: 1 },
    { label: "FEFO", value: 2 },
    { label: "LIFO", value: 3 },
  ])

  const updateAddQuantity = (number) => {
    quantityValue.add = number
  }

  const onModalOpen = () => {
    
  };

  const fetchReward = () => {
    let reward = props.rewardDetail
    fetchPrivilegeEntryDetail.payload.Inventory_Id = router.currentRoute.params.ref
    fetchPrivilegeEntryDetail.payload.Privilege_Id = reward.privilege_id
    store.dispatch('api/apiRequest' , fetchPrivilegeEntryDetail).then(response => {
      if(response.status == "success"){
        let resp = response.data.resp
        formReward.entryId = resp.entry_id
        formReward.name = resp.privilege.name_en
        formReward.reference = resp.privilege.alt_reference
        formReward.image = resp.privilege.image_url
        formReward.privilegeType = resp.privilege.type_desc
        formReward.couponType = resp.privilege.cpc_type_desc
        formReward.couponTypeVal = resp.privilege.cpc_type
        qtyTotal.value = resp.remaining_qty
        formManageStock.removalStrategy = resp.fullfillment_mode
      }
    }).catch(error => {
    }).finally(() => {

    })
  }

  const onSubmitTransfer = () => {
    loading.form = true;
    let payload = {
      Entry_Id: formReward.entryId, 
      To_Inventory_Id: router.currentRoute.query.transfer,
      Qty: quantityValue.add,
      Note: formReward.note,
      Removal_Stategy: formManageStock.removalStrategy, 
      Req_IdentityId: 1,
    }
    fetchTransferQty.payload = payload
    store.dispatch('api/apiRequest' , fetchTransferQty).then(response => {
      openSuccessModal(
        'ทำรายการสำเร็จ !',
        null,
        'ตกลง',
        () => vm.$emit('onTransfer'),
        () => vm.$emit('onTransfer')
    )
    }).catch(error => {
      openDefaultErrorModal(error);
    }).finally(() => {
      loading.form = false;
    })
  }

  const onCloseModal = () => {
    vm.$emit('onCloseModal');
  };

  onBeforeMount(() => {
    fetchReward();
  });

  return {
    formReward,
    formManageStock,
    quantityValue,
    removalOptions,
    qtyTotal,
    loading,
    onModalOpen,
    updateAddQuantity,
    onSubmitTransfer,
    onCloseModal
  };
}
